import { render, staticRenderFns } from "./HomeworkPoint.vue?vue&type=template&id=16bb31d4&lang=pug&"
import script from "./HomeworkPoint.vue?vue&type=script&lang=js&"
export * from "./HomeworkPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports